import { jsxs, jsx } from 'react/jsx-runtime';
import { Popover } from './Popover2.js';
import styles from './FormLabel3.js';

/** Add labels to your Form elements by placing text within the label, and pass the form component as a child. The different between this component and the FormInputGroup is that you can add a popover to the label*/
const FormLabel = ({ children, isRequired, popover, popoverVariant }) => {
    return (jsxs("label", { className: styles.labelClassNames, children: [jsxs("span", { children: [children, isRequired && jsx("span", { className: styles.isRequiredClassNames, children: "*" })] }), popover && jsx(Popover, { content: popover, popoverVariant: popoverVariant })] }));
};

export { FormLabel };
